
















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: "ControlPanelSwitcher"
})
export default class ControlPanelSwitcher extends Vue {
  id: string;
  @Prop({default: false}) value: boolean;
  @Prop({default: false}) disabled: boolean;
  @Prop() label: string;
  @Prop({default: "on"}) onText: string;
  @Prop({default: "off"}) offText: string;
  @Prop({default: false}) keepIconColor: boolean;

  created() {
    this.id = 'wc_switcher_' + Math.random().toString(36).substr(2, 9);
  }

  onInput(event: any) {
    this.$emit('input', event.target.checked)
    this.$emit('changed', event.target.checked);
  }
}
